import isEmpty from "./helpers/isEmpty";

const parseDot = (htmlContainerQuery) => {
  if (
    document.documentElement.lang &&
    (document.documentElement.lang.toLowerCase() === "dk" ||
      document.documentElement.lang.toLowerCase() === "da" ||
      document.documentElement.lang.toLowerCase() === "de")
  ) {
    const elements = document.querySelectorAll(htmlContainerQuery);
    if (!elements || isEmpty(elements)) {
      return;
    }

    elements.forEach((element) => {
      const parsedContent = element.innerHTML.replace(".", ",");
      element.innerHTML = parsedContent;
    });
  }
};

parseDot(".inclues_list_item_flex > span:last-child");

export default parseDot;
